import { createSelector } from 'reselect';

import getApplicationSelector from '/business/shared/state/selectors/application/getApplicationSelector';

export default createSelector([getApplicationSelector], (application) => {
  if (!application) {
    return null;
  }

  const applicationsInPackage = [application, ...application.siblingApplications];
  const latestApplication = applicationsInPackage.reduce((latest, candidate) => {
    return candidate.reportingStartDate > latest.reportingStartDate ? candidate : latest;
  });

  return latestApplication.id;
});
